import { clickOn } from "../events/click";
import { apartments } from "./apartments";
const sortButton = document.querySelector("#apartamentsList #sort-by");

clickOn("#apartamentsList #sort-by, #apartamentsList #sort-by *", (e) => {
  if (!e.target.closest("button#sort-by")?.classList.contains("active")) {
    initTimer(
      "sortOpened",
      () => {
        sortButton.classList.remove("active");
      },
      2000
    );
  } else {
    removeTimer("sortOpened");
  }
  e.target.closest("button#sort-by").classList.toggle("active");
});
clickOn("#sort-by-container, #sort-by-container *", (e) => {
  sorts[e.target.closest("button")?.dataset.sort]?.();
});

const sorts = {
  "area--up": () => {
    apartments.removeAllOnPage();
		apartments.setFilter("sort", "area--up");
		apartments.hidden = [];
		document.dispatchEvent(
			new CustomEvent("apaprtment_getProducts", {
				detail: {
					postType: "apartment",
					callback: ({ data = [] }) => {
						data = data.sort((a, b) => {
							return b.text.area - a.text.area;
						});
						apartments.hidden = data.map((apartment) => {
							return apartments.template(apartment);
						});

						apartments.addOnPage(apartments.getHidden(4));
						apartments.addMore.spawn();
						apartments.addMoreButton.style.order = apartments.hidden.length + 15
					},
					filters: {
						...apartments.currentFilters,
					}
				},
			})
		);
  },
};

import { initTimer, removeTimer } from "../events/timer";